import { dispatch_event } from 'js/functions';
import { create_div, create_element, clear_el } from 'js/utils';
import { load_swiper_init } from 'modules/carousel/load_swiper';

function init(){

    const popup_con = create_div('map_popup', document.body);
    const content = create_div('popup_content', popup_con)
    popup_con.style.display = 'none';

    const open = ()=>{
        popup_con.style.display = '';
    }

    const close = ()=>{
        popup_con.style.display = 'none';
    }

    create_div('close_btn', content).onclick = close;
    
    let last_location = {};
    document.addEventListener('map/popup/open', ({location})=>{
        
        if( last_location?.name != location.name ) {
            console.log('update', location)
            dispatch_event('map/popup/update', {location});
        }

        last_location = location;
        
        open();
    })
    
    init_title(content);
    init_count(content);
    init_readers(content);
}
init();

function init_title(container){

    const el = create_div('location_name', container, 'Location');
    const update = ({location})=>{
        el.textContent = location.name;
    }

    document.addEventListener('map/popup/update', update)
}

function init_count(container){

    const div = create_div('count_con flex gap-5', container);
    const count = create_element('count', div, '0', 'span')
    create_element('', div, 'Readers Featured', 'span');
    
    const update = ({location})=>{
        count.textContent = location.readers.length;
    }

    document.addEventListener('map/popup/update', update)
}

function init_readers(container){

    load_swiper_init();

    const div = create_div('readers', container);

    div.swiper_prev = create_div('swiper_prev', container);
    div.swiper_next = create_div('swiper_next', container);

    const render_items = (readers)=>{

        if( !readers?.length ) return;

        readers.forEach(reader=>{
            div.append(get_reader_html(reader))
        })

        init_items_carousel(div);
    }
    
    const update = ({location})=>{
        clear_el(div)
        render_items(location.readers)
    }

    document.addEventListener('map/popup/update', update)
}

function init_items_carousel(div){

    if( !Swiper ) return;

    const swiper_wrapper = create_div('swiper-wrapper', div)

    div.querySelectorAll('.item').forEach(el=>{
        const swiper_slide = create_div('swiper-slide', swiper_wrapper)
        swiper_slide.append(el)
    })

    const swiper = new Swiper(div, {
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            prevEl: div.swiper_prev,
            nextEl: div.swiper_next,
        },
        pagination: {
            clickable: true,
            el: create_div('swiper-pagination', div),
        }
    });

}


function get_reader_html(reader){

    const el = create_div('item reader')

    const image = create_div('c1 image', el)

    if( reader.image_url ) {
        image.style.backgroundImage = `url(${reader.image_url})`;
    } else {
        image.style.display = 'none';
    }
    
    const c2 = create_div('c2', el)
    create_div('name', c2, reader.name);
    create_div('position_location', c2, reader.position__location);
    create_div('content', c2, reader.content);

    const links = create_div('links', c2);

    if( reader.instagram ) {
        create_link('instagram', links, reader.instagram, get_instagram_link(reader.instagram));
    }

    if( reader.linkedin ) {
        create_link('linkedin', links, reader.linkedin, get_link(reader.linkedin));
    }

    if( reader.link ) {
        create_link('link', links, reader.link, get_link(reader.link));
    }

    return el;
}

function get_link(input){
    if( !input ) return '';
    if( input.includes('http') ) return input;
    return `https://${input}`;
}

function get_instagram_link(input){
    if( !input ) return '';
    if( input.includes('http') ) return input;
    const name = input.split('@')[1]
    return `https://instagram.com/${name}`;
}

function create_link(class_name, container, text, link){

    const a = create_element(class_name, container, null, 'a');
    a.target = '_blank';
    a.href = link;
    
    create_element('', a, text, 'span');

    return a;
}